<template>
<v-container fluid>

  <v-layout
    row
    wrap
    class="mx-2"
    v-if="visible"
  >
    <v-flex
      xs11
      sm5
      md4
      lg3
      xl2
      v-for="(l, $index) in online"
      :key="$index"
    >
      <Card :item="l" />
    </v-flex>
  </v-layout>
</v-container>
</template>


<script>
import Card from './Card';

export default {
  name: 'CardsLine',
  props: ['header', 'data'],
  components: {
    Card,
  },
  data: () => ({
    visible: true,
    page: 1,
  }),
  computed: {
    online() {
      return this.data; //.slice(0, 10);
    }
  }
}
</script>
